import type { HeadingLevel } from '@/features/content/TextUnit';

import { QuestionContent } from './QuestionContent';
import type { NormalizedDisclosureData } from './questionNormalizer';
import styles from './QuestionInfoPanelContent.module.css';

interface SolutionTabContentProps {
  headingLevel?: HeadingLevel;
  solution?: NormalizedDisclosureData;
}

export function SolutionTabContent({
  headingLevel = 4,
  solution,
}: SolutionTabContentProps) {
  if (!solution?.isVisible || solution.units.length === 0) {
    return null;
  }

  return (
    <section className={styles.section} aria-label="Solution">
      <QuestionContent headingLevel={headingLevel} units={solution.units} />
    </section>
  );
}
